module.exports = __webpack_public_path__ + "static/media/woodland-stream-covered-with-snow-816042.fc2360db.jpg";